import messageOnEditCredentials from './alert-messages/messageOnEditCredentials'
import messageOnEditSecretKey from './alert-messages/messageOnEditSecretKey'
import messageOnEditUser from './alert-messages/messageOnEditUser'
import messageOnInviteNewDeveloper from './alert-messages/messageOnInviteNewDeveloper'
import messageOnListMiniApps from './alert-messages/messageOnListMiniApps'
import messageOnListUsers from './alert-messages/messageOnListUsers'
import messageOnGetMiniAppInfo from './alert-messages/messageOnGetMiniAppInfo'
import messageOnGetUserInfo from './alert-messages/messageOnGetUserInfo'
import messageOnLogin from './alert-messages/messageOnLogin'
import messageOnSubmitEditedMiniAppInfo from './alert-messages/messageOnSubmitEditedMiniAppInfo'
import messageOnSubmitNewMiniApp from './alert-messages/messageOnSubmitNewMiniApp'
import messageOnSubmitNewUser from './alert-messages/messageOnSubmitNewUser'
import messageOnEditReview from './alert-messages/messageOnEditReview'
import messageOnRejectReview from './alert-messages/messageOnRejectReview'
import messageOnRedefinePassword from './alert-messages/messageOnRedefinePassword'
import messageOnRemoveInvites from './alert-messages/messageOnRemoveInvites'
import messageOnDeleteCredentials from './alert-messages/messageOnDeleteCredentials'
import messageOnCreateCredential from './alert-messages/messageOnCreateCredential'
import messageOnGetRule from './alert-messages/messageOnGetRule'
import messageOnAddRule from './alert-messages/messageOnAddRule'
import messageOnRemoveRule from './alert-messages/messageOnRemoveRule'
import messageOnEditRule from './alert-messages/messageOnEditRule'
import messageOnGetCategories from './alert-messages/messageOnGetCategories'
import messageOnCreateCategory from './alert-messages/messageOnCreateCategory'
import messageOnEditCategory from './alert-messages/messageOnEditCategory'
import messageOnRemoveCategory from './alert-messages/messageOnRemoveCategory'
import messageOnGetCategoryById from './alert-messages/messageOnGetCategoryById'
import messageOnGetFeatureToggleInformations from './alert-messages/messageOnGetFeatureToggleInformations'
import messageOnEditUserMiniAppActions from './alert-messages/messageOnEditUserMiniAppActions'
import messageOnFindAllActions from './alert-messages/messageOnFindAllActions'
import messageOnFindCheckedActions from './alert-messages/messageOnFindCheckedActions'
import messageOnSourceDownload from './alert-messages/messageOnSourceDownload'

export default class AlertMessages {
    static messageOnEditCredentials = status => messageOnEditCredentials(status)
    static messageOnEditSecretKey = status => messageOnEditSecretKey(status)
    static messageOnEditUser = status => messageOnEditUser(status)
    static messageOnInviteNewDeveloper = (status, info) => messageOnInviteNewDeveloper(status, info)
    static messageOnListMiniApps = status => messageOnListMiniApps(status)
    static messageOnListUsers = status => messageOnListUsers(status)
    static messageOnGetMiniAppInfo = status => messageOnGetMiniAppInfo(status)
    static messageOnGetUserInfo = status => messageOnGetUserInfo(status)
    static messageOnLogin = status => messageOnLogin(status)
    static messageOnSubmitEditedMiniAppInfo = (status, info) => messageOnSubmitEditedMiniAppInfo(status, info)
    static messageOnSubmitNewMiniApp = (status, info) => messageOnSubmitNewMiniApp(status, info)
    static messageOnSubmitNewUser = (status, info) => messageOnSubmitNewUser(status, info)
    static messageOnEditReview = status => messageOnEditReview(status)
    static messageOnRejectReview = status => messageOnRejectReview(status)
    static messageOnRedefinePassword = status => messageOnRedefinePassword(status)
    static messageOnRemoveInvites = status => messageOnRemoveInvites(status)
    static messageOnDeleteCredentials = status => messageOnDeleteCredentials(status)
    static messageOnCreateCredential = status => messageOnCreateCredential(status)
    static messageOnGetRule = status => messageOnGetRule(status)
    static messageOnAddRule = (status, info) => messageOnAddRule(status, info)
    static messageOnRemoveRule = status => messageOnRemoveRule(status)
    static messageOnEditRule = status => messageOnEditRule(status)
    static messageOnEditCategory = status => messageOnEditCategory(status)
    static messageOnGetCategories = status => messageOnGetCategories(status)
    static messageOnCreateCategory = status => messageOnCreateCategory(status)
    static messageOnRemoveCategory = status => messageOnRemoveCategory(status)
    static messageOnGetCategoryById = status => messageOnGetCategoryById(status)
    static messageOnGetFeatureToggleInformations = status => messageOnGetFeatureToggleInformations(status)
    static messageOnEditUserMiniAppActions = status => messageOnEditUserMiniAppActions(status)
    static messageOnFindAllActions = status => messageOnFindAllActions(status)
    static messageOnFindCheckedActions = status => messageOnFindCheckedActions(status)
    static messageOnSourceDownload = status => messageOnSourceDownload(status)
}
